const changes = [
  {
    type: 'feature',
    description: 'Changelog and version upgrade mechanism added\n',
  },
];

export default changes;
